export default "__VITE_ASSET__13c98859__"